/** Detect free variable `global` from Node.js. */ function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
var freeGlobal = (typeof global === "undefined" ? "undefined" : _type_of(global)) == 'object' && global && global.Object === Object && global;
module.exports = freeGlobal;
